const {
  VITE_ONLYOFFICE_HOST,
  VITE_ONLYOFFICE_CALLBACK,
  VITE_ONLYOFFICE_BUSINESS_CALLBACK,
  VITE_LOCAL_PRINTER_SERVICE_URL,
  VITE_ONLYOFFICE_FOREIGN_CALLBACK,
  VITE_ONLYOFFICESW_HOST,
  VITE_ONLYOFFICE_COMMON_CALLBACK
} = import.meta.env;
/**
 * 七牛云域名前缀
 */
export const publicFileHost = "https://source.wushan-gzc.com";
export const wuyePublicFileHost = "https://f.yugongzheng.com";
/**
 * onlyoffice域名
 */
export const onlyofficeHost = VITE_ONLYOFFICE_HOST;
/**
 * onlyoffice域名(版本8)
 */
export const onlyofficeHostSw = VITE_ONLYOFFICESW_HOST;
/**
 * onlyoffice回调地址
 */
export const onlyofficeCallback = VITE_ONLYOFFICE_CALLBACK;
/**
 * onlyoffice业务文件回调地址
 */
export const onlyofficeBusinessCallback = VITE_ONLYOFFICE_BUSINESS_CALLBACK;
/**
 * onlyoffice业务文件回调地址(涉外)
 */
export const onlyofficeForeignCallback = VITE_ONLYOFFICE_FOREIGN_CALLBACK;
/**
 * onlyoffice业务文件回调地址(涉外)
 */
export const onlyofficeCommonCallback = VITE_ONLYOFFICE_COMMON_CALLBACK;

export const localPrinterServiceUrl = VITE_LOCAL_PRINTER_SERVICE_URL;
